import { TableCellType } from "../../../components/custom-table/table";

/** Debounce delay in ms before fetching ICD description for manual entry. */
export const ICD_DESCRIPTION_DEBOUNCE_MS = 500;

/**
 * Placeholder shown in the description field while an ICD description lookup is
 * in flight. Treated as "no description" when resolving the value for save.
 */
export const ICD_DESCRIPTION_LOADING_PLACEHOLDER = "Loading...";

/** Sentinel option for manually entered Dx change reason/source values. */
export const DX_CODE_CHANGE_OTHER_OPTION = "Other";

/** form_options document id for Dx-code change reason choices. */
export const DX_CODE_CHANGE_REASONS_FORM_OPTION_ID = "dx_code_change_reasons";

/** form_options document id for Dx-code change source choices. */
export const DX_CODE_CHANGE_SOURCES_FORM_OPTION_ID = "dx_code_change_sources";

/** Column definitions for the patient Dx codes table inside the modal. */
export const CLINICAL_DATA_TABLE_COLUMNS = [
  {
    label: "ICD Code",
    key: "icd10_code",
    order: 1,
    width: 15,
    type: TableCellType.STRING,
    sortable: false,
  },
  {
    label: "Description",
    key: "icd10_desc",
    order: 2,
    width: 35,
    type: TableCellType.STRING,
    sortable: false,
  },
  {
    label: "Recorded Date",
    key: "recorded_date",
    order: 3,
    width: 15,
    type: TableCellType.DATE,
    sortable: false,
  },
  {
    label: "Valid Drugs",
    key: "valid_drugs",
    order: 4,
    width: 20,
    type: TableCellType.STRING,
    sortable: false,
  },
  {
    label: "Sources",
    key: "source",
    order: 5,
    width: 15,
    type: TableCellType.STRING,
    sortable: false,
  },
];
